<template lang="pug">
  v-dialog(
    :value="true"
    v-bind="dialogProps"
    @click:outside="$modals.close()"
  ).scroll
    component(
      :is="component"
      v-bind="componentProps"
      v-on="componentProps"
    )

</template>

<script>
export default {
  props: {
    title: { type: String, default: null },
    message: { type: String, default: null },
    component: { type: [Object, String], default: null },
    componentProps: { type: Object, default: () => ({}) },

    dialogProps: {
      type: Object,
      default: () => ({
        width: 560,
      }),
    },
  },
};
</script>
